<template >
  <div class="productautoH5" ref="productautoH5">
    <div class="auto-header">
      <div class="ah-top">
        <div class="aht-tit">微商城</div>
        <div class="aht-tip">
          微商城作为新的售货渠道，拥有独立商品库、订单跟踪、配送服务等多种功能，使得商家在销售方面变得更轻松。
        </div>
      </div>
      <div class="ah-bottom" @click.stop="gotowx">立即开通</div>
    </div>
    <div class="auto-process">
      <div class="ap-tip">快速开通上线</div>
      <div class="ap-item top">
        <img src="@/assets/newdownload/wpcl1.png" alt="" class="api-left" />
        <div class="api-right">
          <div class="apir-tit">第一步：开通应用</div>
          <div class="apir-tip">
            登录收银系统后台，在应用市场找到微商城，进行开通
          </div>
        </div>
      </div>
      <img src="@/assets/newdownload/arrow.png" alt="" class="ap-arrow" />
      <div class="ap-item">
        <img src="@/assets/newdownload/wpcl2.png" alt="" class="api-left" />
        <div class="api-right">
          <div class="apir-tit">第二步：授权小程序</div>
          <div class="apir-tip">
            在「微商城-第三方授权」进行小程序授权，若无小程序请先申请小程序
          </div>
        </div>
      </div>
      <img src="@/assets/newdownload/arrow.png" alt="" class="ap-arrow" />
      <div class="ap-item">
        <img src="@/assets/newdownload/wpcl3.png" alt="" class="api-left" />
        <div class="api-right">
          <div class="apir-tit">第三步：微商城设置</div>
          <div class="apir-tip">
            对商城配置、商品进行自定义设置，打造专属微商城
          </div>
        </div>
      </div>
    </div>
    <div class="auto-good">
      <div class="ag-tit">独立商品库</div>
      <div class="ag-tip">
        微商城支持单独设置商品信息，为不同业务场景的商户提供不同的应用能力
      </div>
      <div class="ag-item top1">
        <div class="agi-content">
          <div class="agic-tit">批量添加商品</div>
          <div class="agic-tip">
            将系统已有商品批量添加到微商城形成全新商品库
          </div>
        </div>
        <img src="@/assets/newdownload/autogood1.png" alt="" class="agi-img" />
      </div>
      <div class="ag-item top2">
        <div class="agi-content">
          <div class="agic-tit">自定义</div>
          <div class="agic-tip">自定义商品别名、库存等信息</div>
        </div>
        <img src="@/assets/newdownload/autogood3.png" alt="" class="agi-img" />
      </div>
      <div class="ag-item top3">
        <div class="agi-content">
          <div class="agic-tit">上下架状态</div>
          <div class="agic-tip">可以单独设置商品是否上架</div>
        </div>
        <img src="@/assets/newdownload/autogood2.png" alt="" class="agi-img" />
      </div>
    </div>
    <div class="auto-page">
      <div class="ap-tit">简单易用</div>
      <div class="ap-tip">
        简介的页面设计、便捷的下单流程、帮助用户降低使用学习成本
      </div>
      <img src="@/assets/newdownload/autopagebg2.png" alt="" class="ap-img" />
    </div>
    <div class="auto-track">
      <div class="at-tit">订单智能跟踪</div>
      <div class="at-tip">
        微商城订单单独汇总，商家可清楚了解订单状态并对订单进行相应操作
      </div>
      <div class="at-item">
        <div class="ati-tit">多维度筛选订单</div>
        <div class="ati-tip">
          从时间、商品、订单状态、提货方式等维度帮助商家精准筛选出需要的订单
        </div>
      </div>
      <div class="at-item">
        <div class="ati-tit">订单详情</div>
        <div class="ati-tip">
          包含用户信息、订单状态、商品信息、配送状态、订单金额等信息
        </div>
      </div>
      <div class="at-item">
        <div class="ati-tit">订单操作</div>
        <div class="ati-tip">
          不同状态的订单可进行不同的操作，如：发货、退款、明细导出等
        </div>
      </div>
      <div class="at-item">
        <div class="ati-tit">售后管理</div>
        <div class="ati-tip">售后订单（退款、退货）统一处理</div>
      </div>
      <div class="at-item">
        <div class="ati-tit">订单设置</div>
        <div class="ati-tip">
          商家可对特定订单进行统一设置，如：退款是否需要审核、限时付款、运费设置等
        </div>
      </div>
    </div>
    <div class="auto-prop">
      <div class="ap-tit">店铺宣传秒触达</div>
      <div class="ap-tip">
        商家可以在「商城配置」中上传公告、banner，快速精准触达用户
      </div>
      <img src="@/assets/newdownload/wxpcr.png" alt="" class="ap-img" />
    </div>
    <div class="auto-openstore">
      <div class="ao-tit">多渠道开店</div>
      <div class="ao-tip">打通微信、支付宝、抖音等多个平台，多渠道引流</div>
      <div class="ao-row">
        <div class="aor-item">
          <img src="@/assets/newdownload/wxccl1.png" alt="" class="aori-img" />
          <div class="aori-name">H5微商城</div>
        </div>
        <div class="aor-item">
          <img src="@/assets/newdownload/wxccl2.png" alt="" class="aori-img" />
          <div class="aori-name">微信小程序</div>
        </div>
      </div>
      <div class="ao-row">
        <div class="aor-item">
          <img src="@/assets/newdownload/wxccl3.png" alt="" class="aori-img" />
          <div class="aori-name">支付宝小程序</div>
        </div>
        <div class="aor-item">
          <img src="@/assets/newdownload/wxccl4.png" alt="" class="aori-img" />
          <div class="aori-name">抖音小店</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  activated() {
    this.$refs.productautoH5.scrollIntoView();
  },
  methods: {
    gotowx() {
      location.href = "https://www.fp1123.com/fpPos/#/microMall/mallSituation";
    },
  },
};
</script>

<style lang="less" scoped>
.productautoH5 {
  width: 750px;
  .auto-header {
    width: 750px;
    height: 1000px;
    background: url("~@/assets/newdownload/autoheader.png");
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .ah-top {
      margin-top: 80px;
      padding: 0 65px;
      .aht-tit {
        font-weight: 500;
        font-size: 64px;
        line-height: 80px;
        color: #1f2329;
        text-align: center;
      }
      .aht-tip {
        margin-top: 42px;
        font-weight: 400;
        font-size: 28px;
        line-height: 40px;
        color: #1f2329;
        text-align: center;
      }
    }
    .ah-bottom {
      width: 212px;
      height: 64px;
      background: #2f54eb;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      border-radius: 6px;
      font-weight: 400;
      font-size: 32px;
      line-height: 64px;
      color: #ffffff;
      text-align: center;
      margin-bottom: 43px;
      &:active {
        background: #5c8cff;
      }
    }
  }
}
.auto-process {
  width: 750px;
  height: 848px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ap-tip {
    margin-top: 64px;
    font-weight: 500;
    font-size: 40px;
    line-height: 48px;
    color: #292929;
  }
  .ap-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 750px;
    height: 140px;
    &.top {
      margin-top: 30px;
    }
    .api-left {
      width: 140px;
      height: 140px;
      background: #f3f7fe;
      border-radius: 100px;
      margin-right: 36px;
    }
    .api-right {
      width: 464px;
      .apir-tit {
        font-weight: 500;
        font-size: 32px;
        line-height: 40px;
        color: #292929;
      }
      .apir-tip {
        margin-top: 16px;
        font-weight: 400;
        font-size: 26px;
        line-height: 42px;
        color: #51565d;
      }
    }
  }
  .ap-arrow {
    margin: 30px 0;
    align-self: flex-start;
    margin-left: 112px;
    width: 25.33px;
    height: 23px;
  }
}
.auto-good {
  width: 750px;
  height: 1428px;
  background: url("~@/assets/newdownload/autogoodbg.png");
  background-size: 100%;
  display: flex;
  flex-direction: column;
  // align-items: center;
  overflow: hidden;
  .ag-tit {
    margin-top: 64px;
    font-weight: 500;
    font-size: 40px;
    line-height: 58px;
    color: #292929;
    align-self: center;
  }
  .ag-tip {
    margin-top: 24px;
    width: 560px;
    font-weight: 400;
    font-size: 26px;
    line-height: 34px;
    color: #51565d;
    text-align: center;
    align-self: center;
  }
  .ag-item {
    display: flex;
    // align-items: center;
    position: relative;
    &.top1 {
      height: 476px;
      .agi-img {
        height: 476px;
        position: absolute;
        left: 300px;
      }
      .agi-content {
        margin-top: 108px;
        margin-left: 55px;
      }
    }
    &.top2 {
      height: 300px;
      justify-content: flex-end;
      .agi-img {
        height: 420px;
        position: absolute;
        top: -80px;
        right: 310px;
      }
      .agi-content {
        margin-top: 14px;
        margin-right: 55px;
      }
    }
    &.top3 {
      height: 387px;
      .agi-img {
        height: 476px;
        position: absolute;
        left: 318px;
        top: -40px;
      }
      .agi-content {
        margin-top: 50px;
        margin-left: 55px;
      }
    }
    // .agi-img {
    //   height: 476px;
    //   position: absolute;
    // }
    .agi-content {
      width: 261px;
      .agic-tit {
        font-weight: 500;
        font-size: 32px;
        line-height: 40px;
        color: #2f54eb;
      }
      .agic-tip {
        margin-top: 16px;
        font-weight: 400;
        font-size: 26px;
        line-height: 42px;
        color: #51565d;
      }
    }
  }
}
.auto-page {
  width: 750px;
  height: 840px;
  background: url("~@/assets/newdownload/autopagebg.png");
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ap-tit {
    margin-top: 80px;
    font-weight: 500;
    font-size: 40px;
    line-height: 48px;
    color: #1f2329;
  }
  .ap-tip {
    margin-top: 24px;
    width: 560px;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
    color: #1f2329;
  }
  .ap-img {
    margin-top: 28px;
    width: 610px;
    height: 450px;
  }
}
.auto-track {
  width: 750px;
  height: 1224px;
  background: url("~@/assets/newdownload/autotrackbg.png");
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .at-tit {
    margin-top: 64px;
    font-weight: 500;
    font-size: 40px;
    line-height: 58px;
    color: #292929;
  }
  .at-tip {
    margin-top: 24px;
    width: 640px;
    font-weight: 400;
    font-size: 26px;
    line-height: 34px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #51565d;
  }
  .at-item {
    margin-top: 24px;
    padding: 24px;
    width: 640px;
    height: 172px;
    border: 1px solid #51565d;
    border-radius: 8px;
    .ati-tit {
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #292929;
    }
    .ati-tip {
      margin-top: 16px;
      font-weight: 400;
      font-size: 26px;
      line-height: 34px;
      color: #51565d;
    }
  }
}
.auto-prop {
  width: 750px;
  height: 836px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ap-tit {
    margin-top: 64px;
    font-weight: 500;
    font-size: 40px;
    line-height: 58px;
    color: #292929;
  }
  .ap-tip {
    margin-top: 24px;
    width: 640px;
    font-weight: 400;
    font-size: 26px;
    line-height: 34px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #51565d;
  }
  .ap-img {
    margin-top: 50px;
    width: 683px;
    height: 508px;
  }
}
.auto-openstore {
  width: 750px;
  height: 898px;
  background: url("~@/assets/newdownload/wxchannelp.png");
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ao-tit {
    margin-top: 64px;
    font-weight: 500;
    font-size: 40px;
    line-height: 58px;
    color: #292929;
  }
  .ao-tip {
    margin-top: 24px;
    width: 620px;
    font-weight: 400;
    font-size: 26px;
    line-height: 34px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #51565d;
  }
  .ao-row {
    margin-top: 50px;
    display: flex;
    align-items: center;
    gap: 120px;

    .aor-item {
      width: 168px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .aori-img {
        margin-top: 10px;
        width: 160px;
        height: 160px;
        border-radius: 8px;
      }
      .aori-name {
        margin-top: 16px;
        font-weight: 400;
        font-size: 28px;
        line-height: 42px;
        color: #1f2329;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/productwxH5.vue